import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/lib/useSettings";
import CompanyDataDialog from "@/components/company/CompanyDataDialog";

export const isProfileComplete = (s) => !!(s?.piva && s?.indirizzo);

// ensure(run, cancel): esegue subito se i dati aziendali ci sono, altrimenti li chiede prima.
export const useCompanyGate = () => {
  const { user } = useAuth();
  const settings = useSettings();
  const [pending, setPending] = useState(null);
  const [done, setDone] = useState(false);
  const ready = settings != null;
  const ok = done || user?.role !== "admin" || isProfileComplete(settings);
  const ensure = (run, cancel) => (ok || !ready ? run?.() : setPending({ run, cancel }));
  const close = () => { pending?.cancel?.(); setPending(null); };
  const saved = () => { setDone(true); const p = pending; setPending(null); p?.run?.(); };
  const gate = <CompanyDataDialog open={!!pending} initial={settings} onClose={close} onSaved={saved} />;
  return { ok, ready, ensure, gate };
};

export default useCompanyGate;
